import type {CapabilityUdoColumnResolver} from "~/utilities/capabilityUdoTemplateColumns";
import {resolveFromEventLogs} from "~/modules/activityTimeline/resolver/resolveFromEventLogs";
import {resolveFromEventContainerLogs} from "~/modules/activityTimeline/resolver/resolveFromEventContainerLogs";
import type {
    ActivityCardData,
    ActivityTimelineResolverContext,
} from "~/modules/activityTimeline/types/activityTimeline.types";

export function cardDataResolver(getAdditionalColumns: CapabilityUdoColumnResolver, context: ActivityTimelineResolverContext): Array<ActivityCardData> {
    const fromEventContainerLogs = resolveFromEventContainerLogs(getAdditionalColumns, context);
    const fromEventLogs = resolveFromEventLogs(getAdditionalColumns, context);

    const merged = [...fromEventContainerLogs, ...fromEventLogs];
    const deduped = new Map<string, ActivityCardData>();
    for (const card of merged) {
        deduped.set(String(card.id), card);
    }

    return [...deduped.values()].sort(
        (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
    );
}
